/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
    CREATE_APIKEY_FAILURE, CREATE_APIKEY_REQUEST, CREATE_APIKEY_SUCCESS,
    FETCH_KEYS_REQUEST, FETCH_KEYS_SUCCESS, FETCH_KEYS_FAILURE,
    CREATE_KEYS_REQUEST, CREATE_KEYS_SUCCESS, CREATE_KEYS_FAILURE,
    CREATE_OAUTH_TOKEN_FAILURE, CREATE_OAUTH_TOKEN_REQUEST, CREATE_OAUTH_TOKEN_SUCCESS,
    UPDATE_KEYS_REQUEST, UPDATE_KEYS_SUCCESS, UPDATE_KEYS_FAILURE, 
    MAP_APPLICATION_KEY_REQUEST, MAP_APPLICATION_KEY_SUCCESS, MAP_APPLICATION_KEY_FAILURE, 
    CREATE_API_TEST_KEY_REQUEST, CREATE_API_TEST_KEY_SUCCESS, CREATE_API_TEST_KEY_FAILURE
} from '../types/applicationKeys';
import { KeyList, Key, OauthToken, ApiKey, ApplicationKeyMap } from '../../data/interfaces';

export const fetchKeysRequest = () => {
    return {
        type: FETCH_KEYS_REQUEST
    }
}

export const fetchKeysSuccess = (keys: KeyList) => {
    return {
        type: FETCH_KEYS_SUCCESS,
        payload: keys
    }
}

export const fetchKeysFailure = (error: string) => {
    return {
        type: FETCH_KEYS_FAILURE,
        payload: error
    }
}

export const createKeysRequest = () => {
    return {
        type: CREATE_KEYS_REQUEST
    }
}

export const createKeysSuccess = (keys: Key) => {
    return {
        type: CREATE_KEYS_SUCCESS,
        payload: keys
    }
}

export const createKeysFailure = (error: string) => {
    return {
        type: CREATE_KEYS_FAILURE,
        payload: error
    }
}

export const createApiTestKeyRequest = () => {
    return {
        type: CREATE_API_TEST_KEY_REQUEST
    }
}

export const createApiTestKeySuccess = (key: ApiKey) => {
    return {
        type: CREATE_API_TEST_KEY_SUCCESS,
        payload: key
    }
}

export const createApiTestKeyFailure = (error: string) => {
    return {
        type: CREATE_API_TEST_KEY_FAILURE,
        payload: error
    }
}

export const updateKeysRequest = () => {
    return {
        type: UPDATE_KEYS_REQUEST
    }
}

export const updateKeysSuccess = (keys: Key) => {
    return {
        type: UPDATE_KEYS_SUCCESS,
        payload: keys
    }
}

export const updateKeysFailure = (error: string) => {
    return {
        type: UPDATE_KEYS_FAILURE,
        payload: error
    }
}

export const createOauthTokenRequest = () => {
    return {
        type: CREATE_OAUTH_TOKEN_REQUEST
    }
};

export const createOauthTokenSuccess = (token: OauthToken) => {
    return {
        type: CREATE_OAUTH_TOKEN_SUCCESS,
        payload: token
    }
};

export const createOauthTokenFailure = (error: string) => {
    return {
        type: CREATE_OAUTH_TOKEN_FAILURE,
        payload: error
    }
};

export const createApikeyRequest = () => {
    return {
        type: CREATE_APIKEY_REQUEST
    }
};

export const createApikeySuccess = (apikey: ApiKey) => {
    return {
        type: CREATE_APIKEY_SUCCESS,
        payload: apikey
    }
};

export const createApikeyFailure = (error: string) => {
    return {
        type: CREATE_APIKEY_FAILURE,
        payload: error
    }
};

export const mapApplicationKeyRequest = () => {
    return {
        type: MAP_APPLICATION_KEY_REQUEST
    }
};

export const mapApplicationKeySucess = (applicationKeyMap: ApplicationKeyMap) => {
    return {
        type: MAP_APPLICATION_KEY_SUCCESS,
        payload: applicationKeyMap
    }
};

export const mapApplicationKeyFailure = (error: string) => {
    return {
        type: MAP_APPLICATION_KEY_FAILURE,
        payload: error
    }
};
